var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKonsortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 165 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.635 34H26V70.4491H139.635V34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.09 46.1484H119.261H114.922V49.9771H119.261V58.2471H123.09V49.9771H127.429V46.1484H123.09Z",
    fill: "#022778"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1841 50.0792L51.1149 46.1484H46.3673L42.7939 49.7219H42.0282V46.1484H38.1484V58.2471H42.0282V53.3464H45.0911L45.959 54.1632V58.2471H49.8387L49.7876 52.7848L47.1841 50.0792Z",
    fill: "#022778"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2766 46.1484L50.7031 49.7219V54.7757L54.1745 58.2471H59.4325L62.9039 54.7757V49.6708L59.3815 46.1484H54.2766ZM59.0752 53.3464L57.9011 54.5205H55.757L54.685 53.3464V51.2023L55.8591 50.0282H57.9011L59.1262 51.2534V53.3464H59.0752Z",
    fill: "#022778"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0734 46.1484L89.5 49.7219V54.7757L92.9713 58.2471H98.2294L101.701 54.7757V49.6708L98.1783 46.1484H93.0734ZM97.8721 53.3464L96.6979 54.5205H94.5539L93.4818 53.3464V51.2023L94.656 50.0282H96.6979L97.9231 51.2534V53.3464H97.8721Z",
    fill: "#022778"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.267 52.0188V48.8027L111.664 46.1992H106.61H102.781V58.2979H106.61V54.5713H107.835L110.796 58.2979H115.544L112.174 54.0608L114.267 52.0188ZM110.49 50.7936L110.03 51.2531H106.661V49.6195H109.928L110.49 50.1811V50.7936Z",
    fill: "#022778"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1996 51.917L67.5031 46.1484H63.9297V58.2471H67.7584V52.5296L72.5059 58.2471H76.0794V46.1484H72.1996V51.917Z",
    fill: "#022778"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8438 48.4456V51.7128L79.0899 53.9079H84.348C84.5011 53.9079 84.6543 54.01 84.7053 54.1121C84.7564 54.2142 84.7564 54.3673 84.7053 54.5205C84.6543 54.6736 84.5011 54.7757 84.348 54.7757H76.8438V58.2471H86.3899L88.585 56.052V52.7338L86.3899 50.4876H81.1319C80.9787 50.4876 80.8766 50.4366 80.7745 50.2834C80.6724 50.1303 80.6724 49.9771 80.7745 49.824C80.8766 49.7219 80.9787 49.6198 81.1319 49.6198H88.585V46.1484H79.0899L76.8438 48.4456Z",
    fill: "#022778"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonsortLogo);
export default __webpack_public_path__ + "static/media/konsortLogo.0c3b3a2a5c76cdc6d60b05749069f748.svg";
export { ForwardRef as ReactComponent };